import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16.4822 10.9694C14.733 11.8369 12.4309 12.3147 9.9997 12.3147C7.5686 12.3147 5.26643 11.837 3.51724 10.9694C3.14756 10.786 2.80839 10.5871 2.5 10.3747V11.5044C2.5 11.9294 2.98542 12.6665 4.35356 13.3451C5.84409 14.0844 7.84924 14.4916 9.9997 14.4916C12.1502 14.4916 14.1553 14.0844 15.6458 13.3451C17.014 12.6666 17.4994 11.9295 17.4994 11.5044V10.3747C17.191 10.5872 16.8518 10.7861 16.4822 10.9694Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16.4822 13.9778C14.733 14.8454 12.4309 15.3232 9.9997 15.3232C7.5686 15.3232 5.26643 14.8454 3.51724 13.9778C3.14756 13.7944 2.80839 13.5955 2.5 13.3832V14.5128C2.5 14.9379 2.98542 15.675 4.35356 16.3535C5.84409 17.0928 7.84924 17.5 9.9997 17.5C12.1502 17.5 14.1553 17.0928 15.6458 16.3535C17.014 15.675 17.4994 14.9378 17.4994 14.5128V13.3832C17.191 13.5955 16.8518 13.7945 16.4822 13.9778Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M15.6464 3.64648C14.1559 2.90718 12.1508 2.5 10.0003 2.5C7.84984 2.5 5.84469 2.90718 4.35416 3.64648C2.98608 4.32512 2.5006 5.0622 2.5006 5.48719C2.5006 5.91218 2.98602 6.64933 4.35416 7.32797C5.84469 8.06727 7.84984 8.47445 10.0003 8.47445C12.1508 8.47445 14.1559 8.06727 15.6464 7.32797C17.0146 6.64941 17.5 5.91233 17.5 5.48719C17.5 5.06213 17.0146 4.32505 15.6464 3.64648Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16.4822 7.96077C14.733 8.82833 12.4309 9.30614 9.9997 9.30614C7.5686 9.30614 5.26643 8.8284 3.51724 7.96077C3.14756 7.77738 2.80839 7.57848 2.5 7.36613V8.49577C2.5 8.92083 2.98542 9.65791 4.35356 10.3365C5.84409 11.0758 7.84924 11.483 9.9997 11.483C12.1502 11.483 14.1553 11.0758 15.6458 10.3365C17.014 9.65791 17.4994 8.92083 17.4994 8.49577V7.36613C17.191 7.57848 16.8518 7.77738 16.4822 7.96077Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }